import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import {V2App} from "./V2App";

document.documentElement.dataset.theme="light";
import {V2PublicFeedback} from "./V2Message";
import "./styles.css";
import "./v2-theme.css";
import "./v23.css";

if("serviceWorker" in navigator)window.addEventListener("load",()=>void navigator.serviceWorker.register("/sw.js").catch(()=>{}));
createRoot(document.getElementById("root")!).render(<StrictMode>{location.pathname==="/feedback"?<V2PublicFeedback/>:<V2App/>}</StrictMode>);
import "./v231.css";
import "./v24.css";
import "./v265.css";
import "./v266.css";
import "./v301.css";
import "./v303.css";

import "./v400.css";

import "./v401.css";
